import type { AudioReactiveConfig } from '../types';

/**
 * Resolve the audio-reactive config for an in-place portal destination.
 *
 * This is deliberately portal-local rather than module-global: a later, unrelated createViewer()
 * call in the same document must not inherit settings just because the ambient singleton is still
 * alive. The fetched destination owns any explicit setting, including enabled:false.
 */
export function inheritPortalAudioReactiveConfig(
    destinationConfig: AudioReactiveConfig | undefined,
    sourceConfig: AudioReactiveConfig | undefined,
    persistentBedActive: boolean
): AudioReactiveConfig | undefined {
    if (destinationConfig !== undefined) return destinationConfig;
    if (!persistentBedActive || !sourceConfig?.enabled || (sourceConfig.source ?? 'scene') !== 'scene') {
        return undefined;
    }
    return { ...sourceConfig };
}
